import { PaginationParams } from 'enums/paginationParams';

export const getFilterConditionByName = (name: string) => {
  switch (name) {
    case 'from':
      return 'gte';
    case 'to':
      return 'lte';
    case 'fromDate':
      return 'gte';
    case 'toDate':
      return 'lte';
    default:
      return '';
  }
};

export const buildRequestParams = ({
  page,
  pageSize,
  sortBy,
  filters,
}: BasicPaginationProps): any => {
  const params = {};
  if (page) {
    // eslint-disable-next-line dot-notation
    params[PaginationParams.Page] = page;
  }

  if (pageSize) {
    // eslint-disable-next-line dot-notation
    params[PaginationParams.PageSize] = pageSize;
  }

  if (filters && filters.length > 0) {
    // eslint-disable-next-line dot-notation
    params[PaginationParams.Filter] = filters
      .map(
        filter =>
          `${filter.columnId}${`[${filter.condition ? filter.condition : 'equals'}]`}:${
            filter.value
          }`,
      )
      .join('~');
  }

  if (sortBy && sortBy.length > 0) {
    // eslint-disable-next-line dot-notation
    params[PaginationParams.SortBy] = sortBy
      .flatMap(sort => `${sort.columnId}:${sort.order}`)
      .join(',');
  }

  return params;
};
